import { useSearchParams } from "react-router-dom";

export const useAppSearchParams = () => {
	const [searchParams] = useSearchParams();

	const gameId = Number(searchParams.get("game_id") ?? "");
	const userId = Number(searchParams.get("user_id") ?? "");

	return {
		gameId,
		userId,
	};
};
